import { JavaAPI, JAVA_SERVICE_ENDPOINTS } from '@buildwise/libs/services';
import { SuggestionContactType } from '../queries';

class SuggestionContactAPI extends JavaAPI {
  public getSuggestionContacts({ companyId }: { companyId: string }) {
    return this.get(
      JAVA_SERVICE_ENDPOINTS.GET_SUGGESTION_CONTACTS.replace(':companyId', companyId),
    );
  }

  public deleteSuggestionContact({ id, companyId }: { id: string; companyId: string }) {
    return this.delete(
      JAVA_SERVICE_ENDPOINTS.DELETE_SUGGESTION_CONTACT.replace(':companyId', companyId).replace(
        ':id',
        id,
      ),
    );
  }

  public addSuggestionContact(payload: {
    companyId: string;
    groupName: string;
    region: string;
    owner: string;
  }) {
    return this.post(
      JAVA_SERVICE_ENDPOINTS.SAVE_SUGGESTION_CONTACT.replace(':companyId', payload.companyId),
      payload,
    );
  }

  public saveSuggestionContact(payload: SuggestionContactType) {
    return this.put(
      JAVA_SERVICE_ENDPOINTS.SAVE_SUGGESTION_CONTACT.replace(':companyId', payload.companyId),
      payload,
    );
  }
}

const suggestionContactAPI = new SuggestionContactAPI();
export default suggestionContactAPI;
